import { render, staticRenderFns } from "./viewStudents.vue?vue&type=template&id=77b48326&scoped=true&"
import script from "./viewStudents.vue?vue&type=script&lang=js&"
export * from "./viewStudents.vue?vue&type=script&lang=js&"
import style0 from "./viewStudents.vue?vue&type=style&index=0&id=77b48326&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77b48326",
  null
  
)

export default component.exports